/**
 * The build identity the error loggers stamp on every report (captureError, useErrorTracking).
 *
 * CRA bakes `REACT_APP_VERSION` at build time (the deploy workflow sets it to the deployed commit), so this
 * module is a plain read there. The Vite apps CANNOT use it: Vite/Rolldown compiles shared code's
 * `process.env.REACT_APP_*` to `{}.REACT_APP_*` (always undefined), so an app that bundles the shared error logger
 * redirects THIS module to its own stub that reads its baked src/generated/appVersion.json (client-tech does, in
 * vite.config.ts stubSharedComponents). Keep the export name and type identical in every stub.
 *
 * Callers supply their own fallback (captureError '0.0.0', useErrorTracking '1.0.0'), so an unstamped build is
 * still visibly different from a stamped one.
 */
export const APP_VERSION: string | undefined = process.env.REACT_APP_VERSION || undefined;
